/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} More_EllipsisInputs */

const en_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More...`)
};

const fr_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus...`)
};

const de_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr...`)
};

const it_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di più...`)
};

const ru_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Более...`)
};

const es_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más...`)
};

const zh_cn2_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多的...`)
};

const ja_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっと...`)
};

const hi_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक...`)
};

const pt_pt2_more_ellipsis = /** @type {(inputs: More_EllipsisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais...`)
};

/**
* | output |
* | --- |
* | "More..." |
*
* @param {More_EllipsisInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const more_ellipsis = /** @type {((inputs?: More_EllipsisInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<More_EllipsisInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_more_ellipsis(inputs)
	if (locale === "de") return de_more_ellipsis(inputs)
	if (locale === "it") return it_more_ellipsis(inputs)
	if (locale === "ru") return ru_more_ellipsis(inputs)
	if (locale === "es") return es_more_ellipsis(inputs)
	if (locale === "zh-CN") return zh_cn2_more_ellipsis(inputs)
	if (locale === "ja") return ja_more_ellipsis(inputs)
	if (locale === "hi") return hi_more_ellipsis(inputs)
	if (locale === "pt-PT") return pt_pt2_more_ellipsis(inputs)
	return en_more_ellipsis(inputs)
});